// import { useState } from "react";
// import API from "../api/api";
// import { useNavigate } from "react-router-dom";

// export default function Login() {
//   const [username, setU] = useState("");
//   const [password, setP] = useState("");
//   const navigate = useNavigate();

//   const login = () => {
//     API.post("/auth/login", { username, password })
//       .then((res) => {
//         localStorage.setItem("token", res.data.token);
//         navigate("/dashboard");
//       })
//       .catch(() => alert("Invalid credentials"));
//   };

//   return (
//     <div className="p-6 max-w-md mx-auto">
//       <h1 className="text-3xl font-bold mb-4">Admin Login</h1>

//       <input
//         className="theme-border p-2 rounded"
//         placeholder="Username"
//         onChange={(e) => setU(e.target.value)}
//       />

//       <input
//         className="theme-border p-2 rounded"
//         type="password"
//         placeholder="Password"
//         onChange={(e) => setP(e.target.value)}
//       />

//       <button
//         onClick={login}
//         className="bg-blue-600 text-white px-4 py-2 rounded"
//       >
//         Login
//       </button>
//     </div>
//   );
// }

import { useState } from "react";
import API from "../api/api";
import { useNavigate } from "react-router-dom";

export default function Login() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const login = async () => {
    if (!username || !password) {
      alert("Please enter username and password");
      return;
    }

    try {
      setLoading(true);
      const res = await API.post("/auth/login", { username, password });
      localStorage.setItem("token", res.data.access_token);
      localStorage.setItem("user", JSON.stringify(res.data.user));
      navigate("/dashboard/articles");
    } catch (err) {
      alert("Invalid credentials");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex items-center justify-center bg-gradient-to-br from-red-50 to-gray-100 px-4">

      {/* LOGIN CARD */}
      <div className="w-full max-w-md bg-white rounded-2xl shadow-xl border border-red-200 p-8">

        {/* HEADER */}
        <div className="text-center mb-6">
          <h1 className="text-3xl font-bold text-gray-900">
            Admin Login
          </h1>
          <p className="text-sm text-gray-500 mt-1">
            Sign in to manage articles
          </p>
        </div>

        {/* USERNAME */}
        <div className="mb-4">
          <label className="block text-sm font-semibold text-gray-700 mb-1">
            Username
          </label>
          <input
            type="text"
            placeholder="Enter username"
            className="
              w-full px-4 py-2 rounded-lg
              border border-red-300
              focus:outline-none focus:ring-2 focus:ring-red-400
            "
            value={username}
            onChange={(e) => setUsername(e.target.value)}
          />
        </div>

        {/* PASSWORD */}
        <div className="mb-6">
          <label className="block text-sm font-semibold text-gray-700 mb-1">
            Password
          </label>
          <input
            type="password"
            placeholder="Enter password"
            className="
              w-full px-4 py-2 rounded-lg
              border border-red-300
              focus:outline-none focus:ring-2 focus:ring-red-400
            "
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </div>

        {/* LOGIN BUTTON */}
        <button
          onClick={login}
          disabled={loading}
          className={`
            w-full py-3 rounded-lg font-semibold text-white
            transition
            ${loading
              ? "bg-gray-400 cursor-not-allowed"
              : "bg-gradient-to-r from-red-600 to-red-500 hover:from-red-700 hover:to-red-600"}
          `}
        >
          {loading ? "Signing in..." : "Login"}
        </button>

        {/* FOOTER */}
        <p className="text-center text-xs text-gray-400 mt-6">
          © {new Date().getFullYear()} Article Admin Panel
        </p>
      </div>
    </div>
  );
}
